export const SocialData = [
    {
        platform:"Github",
        link:"https://github.com/Attull",
        icon:require("../../images/github.png").default
    },
    {
        platform:"Linkedin",
        link:"https://www.linkedin.com/in/atulsharma8/",
        icon:require("../../images/linkedin.png").default
    }
];